<div class="container-fluid merchants pt-5">
  <div class="card">
    <div class="card-body compliance-card-body">
      <div class="col-xl-12 col-md-12 col-12 d-flex flex-row">
        <div class="col-xl-4">
          <app-search-bar
            [value]="searchText"
            (onSearch)="searchInput($event)"
            placeholder="Search ..."
          ></app-search-bar>
        </div>
        <div class="col-xl-4">
          <app-purple-date-picker
            [filter]="filterValue"
            (selectedRangeValueChange)="onDateSelection($event)"
          >
          </app-purple-date-picker>
        </div>
        <div class="col-xl-4 d-flex flex-row justify-content-xl-end">
          <button class="button add-btn ml-1" (click)="onExportUsers()">
            Export
          </button>
        </div>
      </div>

      <div class="col-12 p-0 mt-3">
        <ng-container *ngTemplateOutlet="agGridTemplate"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #agGridTemplate>
  <app-lrc-ag-grid
    [tableDataListItems]="tableDataListItems"
    [pageLimit]="pageLimit"
    [page]="page"
    [hasMore]="hasMore"
    [totalElements]="totalNumberOfRecords"
    [params]="params"
    (onPageChanged)="onPageChange($event)"
    (onPageLimitChanged)="onPageLimitChange($event)"
    (onColumnFilterChanged)="onColumnFilterChange($event)"
  ></app-lrc-ag-grid>
</ng-template>
